import Vue from 'vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent';
import i18n from '@/libs/i18n';

export const showSuccessMessage = (message, title) => {
  Vue.$toast({
    component: ToastificationContent,
    position: 'top-right',
    props: {
      title: `${title || i18n.t('Successful')}`,
      icon: 'CheckIcon',
      variant: 'success',
      text: `${message || i18n.t('Operation Complete Successfully')}`
    }
  });
};

export const showErrorMessage = (message, title) => {
  Vue.$toast({
    component: ToastificationContent,
    position: 'top-right',
    props: {
      title: `${title || i18n.t('Error')}`,
      icon: 'XIcon',
      variant: 'danger',
      text: `${message || i18n.t('An error occurred')}`
    }
  });
};

export const showWarningMessage = (message, title) => {
  Vue.$toast({
    component: ToastificationContent,
    position: 'top-right',
    props: {
      title: `${title || i18n.t('Warning')}`,
      icon: 'AlertTriangleIcon',
      variant: 'warning',
      text: `${message || i18n.t('Warning')}`
    }
  });
};

export const showInfoMessage = (message, title) => {
  Vue.$toast({
    component: ToastificationContent,
    position: 'top-right',
    props: {
      title: `${title || i18n.t('Information')}`,
      icon: '',
      variant: 'info',
      text: `${message}`
    }
  });
};

const toast = {
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
  showInfoMessage
};

export default toast;
